export function enumToStringMap(enumItems: [string, string][]): Map<string, string> {
  return enumItems.reduce((acc, curr) => {
    acc.set(curr[1], curr[0]);
    return acc;
  }, new Map<string, string>());
}

export function enumToNumberMap(
  enumItems: [string, unknown][],
  ignoreDirective?: string,
): Map<number, string> {
  return enumItems
    .filter(x => isNaN(Number(x[0])))
    .reduce((acc, curr) => {
      acc.set(Number(curr[1]), curr[0].replace(ignoreDirective ?? '', ''));
      return acc;
    }, new Map<number, string>());
}
